

































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {Page} from '@/modules/cms/types'
import moment from 'moment'
import * as api from '@/modules/cms/api'

@Component
export default class PageSearch extends Vue {
    /**
     * Id de página
     */
    @Prop({type: [Number, String], default: 0})
    public id: number

    @Action('cms/loadPages')
    public loadPages: (payload: { showLoading: boolean }) => void

    @Prop({type: Boolean, default: false})
    public value: boolean

    @State(state => state.cms.pages)
    public items: Page[]

    public search = ''
    public page = new Page()

    public headers = [
        {text: 'Id', value: 'id'},
        {text: 'Título de la página', value: 'title'},
        {text: 'Fecha de creación', value: 'createdAt'},
        {text: 'Fecha de actualización', value: 'updatedAt'},
    ]

    public select (page: Page) {
        this.$emit('select', this.page = page)
    }

    /**
     * Observa la propiedad id del componente, cuando cambia busca la página
     * asociada al id
     */
    @Watch('id', {immediate: true})
    public async onId (id: number) {
        if (!id || this.page.id === id) {
            return
        }

        this.$emit('loading', true)
        this.$emit('select', this.page = await this.getPage(id))
        this.$emit('loading', false)
    }

    /**
     * Obtiene una única página desde la API
     *
     * @param id
     */
    public async getPage (id: number) {
        return await api.getPage(id)
    }

    /**
     * Al crear el componente se carga la lista de páginas
     */
    public created () {
        return this.loadPages({showLoading: false})
    }

    public fancyDate (time: number): string {
        return moment.unix(time).format('LLL')
    }
}
